const getSocialList = (mobilePhonNr, emailAddrTxt, socialSharing) => {
  if (Object.prototype.toString.call(socialSharing).includes('Array')) {
    const arr = socialSharing.map(({ contactType, value }) => ({
      type: contactType,
      link: value,
      altText: contactType,
      title: value,
    }));
    if (emailAddrTxt) {
      arr.push({
        type: 'email',
        link: emailAddrTxt,
        altText: 'email',
        title: emailAddrTxt,
      });
    }
    if (mobilePhonNr) {
      arr.push({
        type: 'phone',
        link: mobilePhonNr,
        altText: 'phone',
        title: mobilePhonNr,
      });
    }
    return arr;
  }
  const arr = [];
  if (emailAddrTxt) {
    arr.push({
      type: 'email',
      link: emailAddrTxt,
      altText: 'email',
      title: emailAddrTxt,
    });
  }
  if (mobilePhonNr) {
    arr.push({
      type: 'phone',
      link: mobilePhonNr,
      altText: 'phone',
      title: mobilePhonNr,
    });
  }
  return arr;
};

export default getSocialList;
